import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

export const moduleGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const moduleCode = route.data?.['module'] as string | string[] | undefined;

  if (!moduleCode) return true;

  if (Array.isArray(moduleCode)) {
    return moduleCode.some(code => auth.hasModule(code)) || router.createUrlTree(['/dashboard']);
  }

  return auth.hasModule(moduleCode) || router.createUrlTree(['/dashboard']);
};
